// extracted by mini-css-extract-plugin
export var button = "styles-module__button___BWd9b";
export var largeButton = "styles-module__largeButton___IFn4r";
export var proBadge = "styles-module__proBadge___gF04H";
export var roundButtonBase = "styles-module__roundButtonBase___VdH6e";
export var smallButton = "styles-module__smallButton___fYYUI";